import { useEffect, useState } from "react";
import client from "@/lib/api";
import { X } from "lucide-react";

let tagCache = null;
export function useContactTags() {
  const [tags, setTags] = useState(tagCache || []);
  useEffect(() => { client.get("/contact-tags").then(({ data }) => { tagCache = data; setTags(data); }).catch(() => {}); }, []);
  return tags;
}

export const TagPill = ({ tag, onRemove, testid }) => (
  <span className="inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2 py-0.5 text-[11px] font-semibold leading-tight text-indigo-700" data-testid={testid}>
    {tag}
    {onRemove && <button type="button" onClick={onRemove} className="text-indigo-400 hover:text-indigo-700" title="Remove tag"><X className="h-3 w-3" /></button>}
  </span>
);

export function TagInput({ value = [], onChange, label = "Tags", testid = "contact-tags" }) {
  const all = useContactTags();
  const [draft, setDraft] = useState("");
  const add = (t) => {
    const v = (t || "").trim();
    if (v && !value.some((x) => x.toLowerCase() === v.toLowerCase())) onChange([...value, v]);
    setDraft("");
  };
  return (
    <div data-testid={testid}>
      {label && <label className="mb-1.5 block text-xs font-semibold text-slate-600">{label}</label>}
      <div className="flex flex-wrap items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2 py-1.5 focus-within:border-sky-400">
        {value.map((t) => <TagPill key={t} tag={t} onRemove={() => onChange(value.filter((x) => x !== t))} testid={`${testid}-pill-${t}`} />)}
        <input list={`${testid}-list`} value={draft} onChange={(e) => {
          const v = e.target.value;
          const picked = !e.nativeEvent?.inputType || e.nativeEvent.inputType === "insertReplacementText";
          if (picked && all.some((t) => t.name === v)) add(v); else setDraft(v);
        }}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(draft); } else if (e.key === "Backspace" && !draft && value.length) onChange(value.slice(0, -1)); }}
          onBlur={() => draft && add(draft)} placeholder={value.length ? "" : "Type a tag and press Enter, e.g. Resort Manager"}
          className="min-w-[140px] flex-1 border-0 bg-transparent px-1 py-0.5 text-sm focus:outline-none" data-testid={`${testid}-input`} />
        <datalist id={`${testid}-list`}>{all.filter((t) => !value.includes(t.name)).map((t) => <option key={t.name} value={t.name} />)}</datalist>
      </div>
    </div>
  );
}
